import React, { useState } from 'react'
import axios from 'axios'
import SummaryListItem from './SummaryListItem'

function Summary({
  checkedPublishers,
  checkedCategories,
  checkedFormats,
  checkedSupplyTypes,
  setCheckedPublishers,
  setCheckedCategories,
  setCheckedFormats,
  setCheckedSupplyTypes,
  setResultStatus,
  setResultData,
  user,
  hideZeroImpressions,
  setHideZeroImpressions,
}) {
  const [publisherCollapse, setPublisherCollapse] = useState(true)
  const [categoryCollapse, setCategoryCollapse] = useState(false)
  const [formatCollapse, setFormatCollapse] = useState(false)
  const [supplyTypeCollapse, setSupplyTypeCollapse] = useState(false)

  function handleSearch() {
    setResultStatus((prevResultStatus) => !prevResultStatus)
    fetchResultData(checkedPublishers, checkedCategories, checkedFormats, checkedSupplyTypes)
  }

  async function fetchResultData(checkedPublishers, checkedCategories, checkedFormats, checkedSupplyTypes) {
    const token = localStorage.getItem('Impact')

    const publisherData = checkedPublishers.map((publisher) => publisher.id)
    const categoryData = checkedCategories.map((category) => category.id)
    const formatData = checkedFormats.map((format) => format.id)
    const supplyTypeData = checkedSupplyTypes.map((supplyType) => supplyType.name)
    const baseUrl = `${process.env.REACT_APP_API_URL}/api`
    await axios
      .post(
        `${baseUrl}/searchplacementgroup`,
        {
          publishers: publisherData.join(),
          categories: categoryData.join(),
          formats: formatData.join(),
          supplyTypes: supplyTypeData.join(),
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => setResultData(response.data))
  }

  return (
    <div className="open-summary">
      <div className="summary-heading">
        <h3>
          Selected Filters (
          {checkedPublishers.length + checkedCategories.length + checkedFormats.length + checkedSupplyTypes.length})
        </h3>
      </div>
      <div className="summary-container">
        <br />
        <br />
        <div className="summary-content-heading">
          <button className="summary-collapsible" onClick={() => setPublisherCollapse(!publisherCollapse)}>
            <i className={`arrow ${publisherCollapse ? 'down' : 'right'}`}></i> Publishers ({checkedPublishers.length}){' '}
          </button>
        </div>
        {publisherCollapse && (
          <div className="summary-content">
            <ul>
              {checkedPublishers.map((publisher) => {
                return <SummaryListItem items={checkedPublishers} listItem={publisher} unCheck={setCheckedPublishers} />
              })}
            </ul>
          </div>
        )}
        <br />
        <div className="summary-content-heading">
          <button className="summary-collapsible" onClick={() => setCategoryCollapse(!categoryCollapse)}>
            <i className={`arrow ${categoryCollapse ? 'down' : 'right'}`}></i> Categories ({checkedCategories.length})
          </button>
        </div>
        {categoryCollapse && (
          <div className="summary-content">
            <ul>
              {checkedCategories.map((category) => {
                return <SummaryListItem items={checkedCategories} listItem={category} unCheck={setCheckedCategories} />
              })}
            </ul>
          </div>
        )}
        <br />
        <div className="summary-content-heading">
          <button className="summary-collapsible" onClick={() => setFormatCollapse(!formatCollapse)}>
            <i className={`arrow ${formatCollapse ? 'down' : 'right'}`}></i> Formats ({checkedFormats.length}){' '}
          </button>
        </div>
        {formatCollapse && (
          <div className="summary-content">
            <ul>
              {checkedFormats.map((format) => {
                return <SummaryListItem items={checkedFormats} listItem={format} unCheck={setCheckedFormats} />
              })}
            </ul>
          </div>
        )}
        <br />
        <div className="summary-content-heading">
          <button className="summary-collapsible" onClick={() => setSupplyTypeCollapse(!supplyTypeCollapse)}>
            <i className={`arrow ${supplyTypeCollapse ? 'down' : 'right'}`}></i> Inventory Type (
            {checkedSupplyTypes.length}){' '}
          </button>
        </div>
        {supplyTypeCollapse && (
          <div className="summary-content">
            <ul>
              {checkedSupplyTypes.map((supplyType) => {
                return (
                  <SummaryListItem items={checkedSupplyTypes} listItem={supplyType} unCheck={setCheckedSupplyTypes} />
                )
              })}
            </ul>
          </div>
        )}
      </div>
      {user.role === 'admin' && (
        <div className="zeroImpressionSwitch">
          <label class="switch" onClick={() => setHideZeroImpressions((prev) => !prev)}>
            <input
              type="checkbox"
              checked={hideZeroImpressions}
              onClick={() => setHideZeroImpressions((prev) => !prev)}
            />
            <span class="slider round"></span>
          </label>
          <p>Hide results with 0 impressions</p>
        </div>
      )}
      <div className="getresultsbtn">
        <button onClick={handleSearch}>Search</button>
      </div>
    </div>
  )
}

export default Summary
